export const lightTheme = {
    dark: false,
    colors: {
        primary: '#F1B34B', // Orange
        background: '#FFFFFF',
        card: '#F8F9FA',
        text: '#1a1a2e',
        border: '#E2E8F0',
        notification: '#FF4500',
        surface: '#FFFFFF',
        onSurface: '#1a1a2e',
        accent: '#667eea', // Blue
        success: '#4CAF50',
        warning: '#FFC107',
        error: '#F44336',
        subText: '#64748b',
        inputBackground: '#F1F5F9',
        placeholder: '#94A3B8',
    },
};

export const darkTheme = {
    dark: true,
    colors: {
        primary: '#F1B34B', // Orange
        background: '#1a1a2e', // Dark Blue/Navy
        card: '#16213e',
        text: '#E2E8F0',
        border: '#2d3748',
        notification: '#FF4500',
        surface: '#16213e',
        onSurface: '#E2E8F0',
        accent: '#667eea', // Blue
        success: '#66BB6A',
        warning: '#FFD54F',
        error: '#EF5350',
        subText: '#94A3B8',
        inputBackground: '#0f3460',
        placeholder: '#64748b',
    },
};
